import { OverlayContainer } from '@angular/cdk/overlay';
import {Injectable} from '@angular/core';

/**
 * Custom overlay container.
 * This overlay can be set inside WizRoot element then all dialogs will pop inside it.
 */
@Injectable()
export class WizOverlayContainer extends OverlayContainer {

  /**
   * Create custom overlay container and append to ElementRef from directive
   */
  public wizCreateContainer(element: HTMLElement): void {
    const container:HTMLDivElement = document.createElement('div');
    container.classList.add('wiz-overlay-class');

    element.appendChild(container);
    this._containerElement = container;
  }

  /**
   * Prevents default creation of the HTML element directly in document's body, use custom method above
   */
  protected _createContainer(): void {
      return;
  }


}
